// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"656719ae","453":"19ae775b"}[chunkId] + ".chunk.js";
};